// =============================================================================
// PROFILE PAGES LAYOUTS
// =============================================================================

export default {
  path: 'company',
  component: () => import('../../views/admin/companyInfo/index.vue'),
  children: [
    {
      path: '',
      name: 'companyProfile',
      component: () => import(/* webpackChunkName: "companyProfile" */ '../../views/admin/companyInfo/profile/index.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.profile.title',
        layoutStatus: 'profile',
        permission: 'company.show'
      // rule: 'editor'
      }
    },
    {
      path: 'dashboard',
      name: 'companyDashboard',
      component: () => import(/* webpackChunkName: "companyDashboard" */ '../../views/admin/companyInfo/dashboard/companyDashboard.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.companyInfo.dashboard.title',
        layoutStatus: 'profile',
        permission: 'company.show'
      // rule: 'editor'
      }
    },
    {
      path: 'invoices',
      name: 'companyInvoices',
      component: () => import(/* webpackChunkName: "companyInvoices" */ '../../views/admin/companyInfo/sales/companyInvoicesList.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.companyInfo.invoices.title',
        layoutStatus: 'profile',
        permission: 'company.show'
      // rule: 'editor'
      }
    },
    {
      path: 'edit',
      name: 'editCompanyAppInfo',
      component: () => import(/* webpackChunkName: "editCompanyAppInfo" */ '../../views/admin/companyInfo/edit/./editCompanyInfo'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.companyInfo.edit.title',
        layoutStatus: 'profile',
        permission: 'company.update'
      // rule: 'editor'
      }
    }
  ]
}
